//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiStar } from '@mdi/js';

export default {
	data: () => ({
		svgPath: mdiStar,
	}),
};
